import gql from 'graphql-tag';

export default gql`
  mutation createOneDialogMutation(
    $type: String!
    $course: MongoID
    $lesson: MongoID
    $courseCategory: MongoID
    $dialogUsers: [MongoID]
    $isCommonDialog: Boolean
  ) {
    createOneDialogMutation(
      type: $type
      course: $course
      lesson: $lesson
      courseCategory: $courseCategory
      dialogUsers: $dialogUsers
      isCommonDialog: $isCommonDialog
    ) {
      record {
        _id
      }
    }
  }
`;
